import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import SurveyListHeader from "../../../component/layout/MainHeader";
import Svg from "../../../component/Svg";
import Input from "../../../core/Inputs/DefaultInput";

import userIcon from '../../../assets/images/user-icon.png'

import { toast } from 'react-toastify';
import './profile.css';

import Axios from "axios";

import profileImage from "../../../assets/images/survey-video-1.png";
import Button from "../../../core/Button";
import AccountSettingSidebar from "./components/AccountSettingSidebar";
import SurveyListSidebar from "../../../component/layout/MainSidebar";
import { Formik } from "formik";
import { updateUserProfileSchema } from "../../../schema/User";
import CreatableSelect from "react-select/creatable";
import {
  countryList,
  regionList,
  timezoneList,
} from "../../../store/actions/locationActions";
import {
  updateProfileData,
  userDetail,
  updateProfilePicture,
  checkProfileImageExistence,
  uploadProfilePicture,
  removeProfileData
} from "../../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "./NestedMenuToggle";

export default function Profile() {
  const dispatch = useDispatch();
  const { countryData, regionData, timeZoneData } = useSelector(
    (state) => state.locationData
  );
  const { loggedInUserDetail, isAddingUser } = useSelector(
    (state) => state.userData
  );

  const fileInputRef = useRef(null); // Ref for file input field

  const [passwordType, setPasswordType] = useState("password");
  const [timeZones, setTimeZones] = useState([]);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [selectedCountryName, setSelectedCountryName] = useState(null);



  const [formValue, setFormValue] = useState({
    id: "",
    email: "",
    name: "",
    country_code: null,
    region_code: null,
    timezone: null,
    default_region_code: null,
    isEnabled: true,
  });

  const getCountryList = async (regionCode) => {
    let dataToSend = {
      regionCode: regionCode,
    };
    dispatch(countryList(dataToSend));
  };

  const getTimezones = async () => {
    dispatch(timezoneList());
  };

  const getRegionList = async () => {
    dispatch(regionList());
  };

  const getUserDetail = async () => {
    dispatch(userDetail());
  };
  const updateProfile = async (data) => {
    dispatch(updateProfileData(data));
  };

  useEffect(() => {
    getRegionList();
    getTimezones();
    getUserDetail();
  }, []);

  useEffect(() => {
    if (loggedInUserDetail) {
      getCountryList(loggedInUserDetail.region_code);
      setSelectedCountryCode(loggedInUserDetail.country_code);
      setFormValue({
        id: loggedInUserDetail.id,
        email: loggedInUserDetail.email,
        name: loggedInUserDetail.name,
        country_code: loggedInUserDetail.country_code,
        region_code: loggedInUserDetail.region_code,
        timezone: loggedInUserDetail.timezone,
        isEnabled: true,
      });
    }
  }, [loggedInUserDetail]);

  useEffect(() => {
    let tempTimeZones = [];
    Object.keys(timeZoneData).map((ele) => {
      tempTimeZones.push({
        value: timeZoneData[ele].value,
        label: timeZoneData[ele].text,
      });
      setTimeZones(tempTimeZones);
    });
  }, [timeZoneData]);

  useEffect(() => {
    let tempRegions = [];
    Object.keys(regionData).map((ele) => {
      tempRegions.push({
        value: regionData[ele].region_code,
        label: regionData[ele].region_name,
      });
      setRegions(tempRegions);
    });
  }, [regionData]);

  useEffect(() => {
    let tempCountries = [];
    Object.keys(countryData).map((ele) => {
      if (countryData[ele].countrycode === selectedCountryCode) {
        setSelectedCountryName(countryData[ele].name);
      }
      tempCountries.push({
        value: countryData[ele].countrycode,
        label: countryData[ele].name,
      });
      setCountries(tempCountries);
    });
  }, [countryData]);

  useEffect(() => {
    if (!isAddingUser) {
      getUserDetail();
    }
  }, [isAddingUser]);

  // Import any necessary dependencies
 
  
  const [profilename, setprofilename] = useState('')
  const [profile, setprofile] = useState(false)
  const [profileremove, setprofileremove] = useState(false)
  // const [profileStatus, setProfileStatus] = useState('')

  const { profileImageExistenceStatus, profileImage } = useSelector((state) => state.userData)
  const profilePicture = useSelector(state => state.userData.profilePicture);

  

  const handleImageUpload = async (profilePicture, userId) => {
    try {
      await dispatch(uploadProfilePicture(profilePicture, userId));
      toast.success('Profile Picture Uploaded Successfully');
      setprofile(profileImageExistenceStatus)
    } catch (error) {
      // console.error('Error uploading profile picture:', error.message);
      toast.error('An Error Occurred While Uploading Profile Picture');
    }}

  useEffect(() => {
      if (profilePicture) {
          setprofilename(profilePicture)
      }
  }, [profilePicture]);

  useEffect(() => {
      if (profileImage){  
        setprofilename(profileImage)
      }
  }, [profileImage]);

  useEffect(() => {
    if (loggedInUserDetail) {
      dispatch(checkProfileImageExistence(loggedInUserDetail.email));
    }
  }, [loggedInUserDetail, profilename]);

  const removeProfie = () => {
    let data ={ user_id: loggedInUserDetail.id}
    dispatch(removeProfileData(data));
    // setprofilename('')
    // setprofile(false)
    toast.success("Profile Remove Successfully");

    setFormValue({
      ...formValue,
      profileImageExistenceStatus: false
    });
    
    if (fileInputRef.current) {
      fileInputRef.current.value = null; // Reset file input field
    }

      // Axios.post(process.env.REACT_APP_NODE_API_URL + "/users/removeProfile", {
      //   user_id: loggedInUserDetail.id
      // }).then((response) => {
      //     if (response.status == 200) {
      //         toast.success("Profile remove Successfully");
      //         setprofileremove(true)
      //     } else {
      //         toast.error("Profile Failed");
      //     } 
      // });
  }


    return (
      <>
        <div className="d-flex flex-column main-outer-wrapper main-site-wrapper">
          <SurveyListHeader />
          <div id="viewport" className="d-flex">
            <SurveyListSidebar />
            <div className="flex-grow-1 d-flex">
              <AccountSettingSidebar />
              <div className="flex-grow-1 variable-pg-content">
                {/* breadcrumbs here */}
                <div className="custom-breadcrumb">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link
                          to="/admin/dashboard"
                          className="home-item"
                          title="Dashboard"
                        >
                          Home
                        </Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/profile">Settings</Link>
                      </li>
                      {/* <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">General</Link>
                    </li> */}
                      <li className="breadcrumb-item active" aria-current="page">
                        <strong>Account settings</strong>
                      </li>
                    </ol>
                  </nav>
                </div>
                {/* breadcrumbs ends here */}
                <div className="survey-main-container">
                  <div className="page-heading d-lg-none">
                    <div className="d-flex align-items-start">
                      <NestedMenuToggle />
                      <div className="flex-grow-1 ps-3 ps-lg-0">
                        <h1>Account settings</h1>
                      </div>
                    </div>
                  </div>
                  <div className="pagesRow varPg">
                    <div className="profile-wrapper">
                      <div className="account-info border-0 pb-0">
                        <div className="profile-image">
                          <div className="img-wrap">
                            {/* <span>TM</span> */}
                            {/* {loggedInUserDetail.profileImage ? (
                            <img src={"http://localhost:3005/image/" + loggedInUserDetail.profileImage} alt="Profile" className='img-fluid' />
                          ) : (
                            <img src={userIcon} alt="Default Profile" className='img-fluid' />
                          )} */}
                            <img src={profileImageExistenceStatus ? process.env.REACT_APP_NODE_API_URL + "/image/" + profilename : userIcon} alt="" className='img-fluid' />
                          </div>
                          <div className="edit-wrap">
                            <label id="dropdownprofile" data-bs-toggle="dropdown" aria-expanded="false">
                              <Svg name="Edit-Survey" />
                            </label>
                            <ul className="dropdown-menu" aria-labelledby="dropdownprofile">
                              <li className="dropdown-item custom-file-upload" htmlFor="editProfile">
                                <input type="file" name="" accept="image/*" id="editProfile" ref={fileInputRef}   onChange={(e) => {
                                handleImageUpload(e.target.files[0], loggedInUserDetail.id)
                              }} />
                                <span>Update Profile</span>
                              </li>
                              <li className="dropdown-item" onClick={removeProfie}>
                                Remove
                              </li>
                            </ul>
                          </div>
                        </div>
                        <Formik
                          initialValues={formValue}
                          enableReinitialize
                          validationSchema={updateUserProfileSchema}
                          onSubmit={(values, { setSubmitting, resetForm }) => {
                            let dataToSend = {
                              id: values.id,
                              name: values.name,
                              email: values.email,
                              country_code: values.country_code,
                              region_code: values.region_code,
                              timezone: values.timezone,
                            };
                            updateProfile(dataToSend);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                          }) => (
                            <form onSubmit={handleSubmit}>
                              <div className="form-wrapper custom-width">
                                <div className="row gx-12px">
                                  <div className="col-lg-6 position-relative">
                                    <div className="mb-3">
                                      <label htmlFor="">Full Name</label>
                                      <Input
                                        type="text"
                                        view="outlined"
                                        dense={false}
                                        color="default"
                                        label=""
                                        placeholder="Username"
                                        clearButton={true}
                                        success={false}
                                        error={false}
                                        fill={true}

                                        errorHelperText={null}
                                        className={"formsinput"}
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                    {errors.name && (
                                      <div className="validation-msg">
                                        {errors.name}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="mb-3">
                                      <label htmlFor="">Email</label>
                                      <Input
                                        type="email"
                                        name="email"
                                        dense={false}
                                        color="default"
                                        label=""
                                        placeholder="Email"
                                        success={false}
                                        error={false}
                                        fill={true}
                                        errorHelperText={null}
                                        className={"formsinput"}
                                        value={values.email}
                                        onChange={handleChange}
                                        readOnly
                                      />
                                    </div>
                                  </div>

                                  {/* <div className="col-lg-6">
                              <div className="mb-3">
                                <label htmlFor="">Organization Name</label>
                                <Input
                                  type="text"
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  label=""
                                  placeholder="Organization Name"
                                  clearButton={true}
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  className={"formsinput"}
                                />
                              </div>
                            </div> */}
                                  <div className="col-md-6 position-relative">
                                    <div className="mb-3 cstom-select">
                                      <label htmlFor="">Region</label>
                                      <CreatableSelect
                                        value={
                                          regions
                                            ? regions.find(
                                              (option) =>
                                                option.value === values.region_code
                                            )
                                            : ""
                                        }
                                        placeholder={"Select Region"}
                                        options={regions}
                                        onChange={(e) => {
                                          getCountryList(e.value);
                                          setFieldValue("region_code", e.value);
                                        }}
                                      />
                                    </div>
                                    {errors.region_code && touched.region_code && (
                                      <div className="validation-msg">
                                        {errors.region_code}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-6 position-relative">
                                    <div className="mb-3 cstom-select">
                                      <label htmlFor="">Country</label>
                                      <CreatableSelect
                                        value={
                                          countries
                                            ? countries.find(
                                              (option) =>
                                                option.value === values.country_code
                                            )
                                            : ""
                                        }
                                        placeholder={"Select country"}
                                        options={countries}
                                        onChange={(e) => {
                                          setFieldValue("country_code", e.value);
                                        }}
                                      />
                                    </div>
                                    {errors.country_code && touched.country_code && (
                                      <div className="validation-msg">
                                        {errors.country_code}
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-6">
                                    <div className="mb-3 cstom-select">
                                      <label htmlFor="">Timezone</label>
                                      <CreatableSelect
                                        value={
                                          timeZones
                                            ? timeZones.find(
                                              (option) =>
                                                option.value === values.timezone
                                            )
                                            : ""
                                        }
                                        placeholder={"Select Timezone"}
                                        options={timeZones}
                                        onChange={(e) => {
                                          setFieldValue("timezone", e.value);
                                        }}
                                      />
                                    </div>
                                    {errors.timezone && touched.timezone && (
                                      <div className="validation-msg">
                                        {errors.timezone}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="btn-wrap">
                                  <button
                                    className={"formsbutton btn-bordered btn mb-0"}
                                    type="submit"
                                    view="outlined"
                                    color="primary"
                                  >
                                    {isAddingUser ? (
                                      <>
                                        <span
                                          className="white-spinner spinner-border spinner-border-sm"
                                          role="status"
                                          aria-hidden="true"
                                        ></span>
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </>
                                    ) : (
                                      "Save Changes"
                                    )}
                                  </button>
                                </div>
                              </div>
                            </form>
                          )}
                        </Formik>
                      </div>
                      {/* <div className="account-preference">
                  <div className="form-heading">
                    <h4>Account Preferences</h4>
                  </div>

                  <div className="btn-wrap">
                    <a href="#" className="btn btn-danger-text">
                      Delete Account
                    </a>
                  </div>
                </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
